import { render, staticRenderFns } from "./postFacebook.vue?vue&type=template&id=63088422"
import script from "./postFacebook.vue?vue&type=script&lang=js"
export * from "./postFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63088422')) {
      api.createRecord('63088422', component.options)
    } else {
      api.reload('63088422', component.options)
    }
    module.hot.accept("./postFacebook.vue?vue&type=template&id=63088422", function () {
      api.rerender('63088422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postFacebook.vue"
export default component.exports